import { Box } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Container = styled(Box)`
  ${variables.mediaQuery.lessThan('desktop')`   
    margin-top: -10px;
  `}
`;

export const Heading = styled(Box)`
  display: flex;
  justify-content: space-between;
  position: sticky;
  position: -webkit-sticky;
  top: 38px;
  z-index: 10;
  margin-bottom: 0.25rem;
  padding-top: 1.25rem;
  padding-bottom: 0.65rem;
  background-color: ${colorTokens.background.light};
  width: 100%;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 1rem;
    position: relative;
  }
`;

export const RiderActions = styled(Box)`
  display: flex;
  gap: 1rem;

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 1rem;
  }
`;

export const CardsContainer = styled(Box)`
  display: flex;
  gap: 1rem;
  margin-top: 21px;

  @media (max-width: 1240px) {
    flex-wrap: wrap;
  }

  ${variables.mediaQuery.lessThan('tablet')`   
     flex-direction: column;
  `}
`;
